<!--
 * @Author: huangxuejuan
 * @Date: 2022-02-22 10:39:10
 * @Description: loading
-->
<template>
  <div class="load-mask" :style="{ background: backgroundColor }">
    <van-loading :size="size" :type="type" :color="color" />
  </div>
</template>
<script>
import { Loading } from 'vant'

export default {
  name: 'jlLoading',
  components: {
    vanLoading: Loading
  },
  props: {
    type: {
      type: String,
      default: 'spinner'
    },
    color: {
      type: String,
      default: '#888888'
    },
    size: {
      type: Number,
      default: 40
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.1)'
    }
  }
}
</script>

<style scoped lang="less">
.load-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
